// services/drchrono-connection.ts
import { useContext } from "react";
import SessionContext from "../../../../../contexts/session";
import { syncAllDrChronoData } from "../../../../../services/api-integrations-drchrono";

export const useDrChronoConnection = () => {
  const sessionContext = useContext(SessionContext);
  const session = sessionContext?.session;

  const syncWithToken = async (accessToken: string): Promise<void> => {
    if (!session?.clinicId) {
      console.error("No clinic found in session");
      return;
    }

    try {
      const result = await syncAllDrChronoData(session, accessToken);
      console.log("Sync completed:", result);
    } catch (error: any) {
      console.error("Sync failed:", error);
      throw error;
    }
  };

  return {
    syncWithToken,
  };
};
